SpriteSpin.extendApi({
    playForwards: function (frame, options) {
        const data = this.data;
        data.animate = true;
        data.loop = false;
        data.frame = 0;
        data.stopFrame = data.source.length-1;
        data.reverse = false;
        SpriteSpin.updateFrame(data);
        SpriteSpin.applyAnimation(data);
        return this;
    },
    playBackwards: function (frame, options) {
        const data = this.data;
        data.animate = true;
        data.loop = false;
        data.frame = data.source.length-1;
        data.stopFrame = 0;
        data.reverse = true;
        SpriteSpin.updateFrame(data);
        SpriteSpin.applyAnimation(data);
        return this;
    }
});

jQuery3_4_1(document).ready(function($){
    class Flipbook {
        constructor(parent) {
            const self = this;
            self.console = new DD_Console();
            if(parent.flipbook){
                self.console.verbose("Flipbook already exists. Early return.");
                return;
            }
            parent.flipbook = self;
            self.parent = $(parent);
            self.awake();
            setTimeout(function(){
                self.start();
            },0);
        }

        on(eventName, callback) {  // Available events: ready | start | end | frame
            const self = this;
            self.emitter.on(eventName, callback);
        }

        off(eventName, callback) {
            const self = this;
            self.emitter.off(eventName, callback);
        }

        awake(){
            const self = this;
            self.console.verbose("AWAKE: Flipbook", self);
            self.emitter = new DD_Emitter(); 
            self.spritespinElement = self.parent.find(".dd-spritespin").first();
            self.ready = false;
            self.isPlaying = false;

            const images = self.parent.data("images") ? self.parent.data("images") : [];
            self.parent.removeAttr("data-images");
            const width = self.parent.data("width") ? self.parent.data("width") : 2560;  // TODO: Get the image size from the uploaded media
            const height = self.parent.data("height") ? self.parent.data("height") : 1770;
            const framerate = self.parent.data("framerate") ? self.parent.data("framerate") : 25;

            const autostart = false;

            self.settings = {
                // VARIABLE SETTINGS
                source:images,
                width:width,
                height:height,  
                // DEFAULT SETTING
                animate: autostart,
                loop: false,
                frameTime: Math.floor(1000/framerate),
                detectSubsampling: false, 
                reverse: false, 
                preloadCount: images.length,
                frame: 0,
                stopFrame: (images.length-1),
                // enableCanvas :true,
                onComplete: function(event, progress){
                    self.handleReady(); 
                },
                onFrame: function(event, data){
                    if(!self.ready){
                        return;
                    }
                    if(!self.isPlaying){
                        self.isPlaying = data.animate;
                        self.handleStart();
                        return;
                    }
                    const fraction = data.reverse ? 1.0 - data.frame / data.frames : data.frame / data.frames;
                    self.emitter.emit("frame", self, fraction);
                    if(data.animate == false) {
                        self.isPlaying = data.animate;
                        self.handleEnd();
                        return;
                    }
                },
            }
        }

        start(){
            const self = this;
            self.console.verbose("START: Flipbook", self);
            self.spritespinElement.spritespin(self.settings);
            self.spritespinApi = self.spritespinElement.spritespin("api");
        }
        
        playForwards() {
            const self = this;
            if(self.ready){
                // self.handleStart();
                self.spritespinApi.playForwards();
            }
        }
        
        playBackwards() {
            const self = this;
            if(self.ready){
                // self.handleStart();
                self.spritespinApi.playBackwards();
            }
        }

        handleReady(){
            // console.log("Flipbook: Ready"); 
            const self = this;
            self.ready = true;
            self.emitter.emit("ready", self);
        }

        handleStart(){
            // console.log("Flipbook: Start Animation");
            const self = this;
            self.parent.addClass("dd-is-playing");
            self.emitter.emit("start", self);
        }

        handleEnd(){
            // console.log("Flipbook: End Animation");
            const self = this;
            // if(!self.ready){
            //     return;
            // }
            self.parent.removeClass("dd-is-playing"); 
            self.emitter.emit("end", self);
        }

        destroy(){
            const self = this;
        
            // Destroy the SpriteSpin instance
            if (self.spritespinElement && self.spritespinElement.spritespin("api")) {
                self.spritespinElement.spritespin("destroy");
            }
        
            // Remove reference from parent DOM element
            if (self.parent && self.parent[0]) {
            self.parent.addClass("dd-lazy");
                delete self.parent[0].flipbook;
            }
        
            // Clear emitter events
            if (self.emitter) {
                self.emitter.events = {}; // remove all listeners
            }
        
            // Null references (optional cleanup)
            self.spritespinElement = null;
            self.spritespinApi = null;
            self.emitter = null;
            self.parent = null;
        }
    }

    // class DDEmitter {  // Using the globally defined DD_Emitter instead
    //     constructor(){
    //         this.events = {};
    //     }
    
    //     on(eventName, callback) {
    //         const self = this;
    //         if (!self.events[eventName]) {
    //             self.events[eventName] = [];
    //         }
    //         self.events[eventName].push(callback);
    //     }
    
    //     off(eventName, callback) {
    //         const self = this;
    //         const eventHandlers = self.events[eventName];
    //         if (eventHandlers) {
    //             self.events[eventName] = eventHandlers.filter(fn => fn !== callback);
    //         }
    //     }
    
    //     emit(eventName, ...args) {
    //         const self = this;
    //         const eventHandlers = self.events[eventName];
    //         if (eventHandlers) {
    //             eventHandlers.forEach(callback => {
    //                 callback(...args);
    //             });
    //         }
    //     }
    // }

    registerOnLoadEvent(function(){
        $(".dd-flipbook:not(.dd-lazy)").each(function(){
            new Flipbook(this);
        })
    });


    // Expose globally
    window.Flipbook = Flipbook;

});
  